/**
 * Sends old in-app paths (/help, /terms, /privacy) to the published copy on techsight.co.za.
 * The current location hash is carried across when asked, so /help#contact still lands on its section.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ExternalRedirectProps {
  to: string;
  keepHash?: boolean;
}

export default function ExternalRedirect({ to, keepHash = false }: ExternalRedirectProps) {
  const { hash } = useLocation();
  const target = keepHash && hash ? `${to.replace(/#.*$/, '')}${hash}` : to;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p className="p-6 text-sm text-gray-600">
      Redirecting… <a href={target} rel="noopener" className="text-[#007a6d] underline">Continue to {target}</a>
    </p>
  );
}
